export default __webpack_public_path__ + "355c6c732e685f27ffa23af9aaad6a67.png";